import { BREAKPOINT_TB, BREAKPOINT_SP } from '../config/_breakpoint';

const body = document.body,
      main = document.querySelector('main'),
      footer = document.querySelector('footer'),
      menuTrigger = document.querySelector('#menu_trigger'),
      menu = document.querySelector('#menu'),
      inertElements= [
        main,
        footer,
      ];

let scrollPosition = 0;

export function openMenu() {
  scrollPosition = window.scrollY;
  body.style.top = `-${scrollPosition}px`;
  body.classList.add('is-menuOpen');
  menuTrigger.setAttribute('aria-label', 'ナビゲーションメニューを閉じる');
  menuTrigger.setAttribute('aria-expanded', 'true');
  menu.setAttribute('aria-hidden', 'false');
  menu.removeAttribute('inert');
  inertElements.forEach(el => el?.setAttribute('inert', ''));
}

export function closeMenu(reason) {
  body.classList.remove('is-menuOpen');
  menuTrigger.setAttribute('aria-label', 'ナビゲーションメニューを開く');
  menuTrigger.setAttribute('aria-expanded', 'false');
  menu.setAttribute('aria-hidden', 'true');
  menu.setAttribute('inert', 'true');
  inertElements.forEach(el => el?.removeAttribute('inert'));
  body.style.top = '';
  if (reason !== 'resize') {
    window.scrollTo(0, scrollPosition);
  }
}

export function menuOpenClose() {
  const expanded = menuTrigger?.getAttribute('aria-expanded') === 'true';
  expanded ? closeMenu() : openMenu();
}

export function menuToggle() {
  if (!menuTrigger || !menu) return;

  menuTrigger.addEventListener('click', menuOpenClose);

  document.querySelectorAll('.menu_link').forEach(el => {
    el.addEventListener('click', () => {
      if (window.innerWidth < BREAKPOINT_TB) {
        closeMenu();
      }
    });
  });

  const mediaQuery = matchMedia(`(min-width: ${BREAKPOINT_TB}px)`);
  const handleMediaChange = (e) => {
    if (e.matches) {
      body.classList.remove('is-menuOpen');
      menu.setAttribute('aria-hidden', 'false');
      menu.removeAttribute('inert');
    } else {
      closeMenu('resize');
    }
  };

  mediaQuery.addEventListener('change', handleMediaChange);
  handleMediaChange(mediaQuery);
}
